import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoneIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 35.872,
	height: 33.31,
	viewBox: "0 0 35.872 33.31",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_8889",
		"data-name": "Path 8889",
		d: "M15.8,32.725,8.318,23.838a2.549,2.549,0,0,0-3.649,0,2.6,2.6,0,0,0,0,3.682l9.277,10.7a2.58,2.58,0,0,0,3.675,0l21.4-28.089a2.6,2.6,0,0,0,0-3.682,2.549,2.549,0,0,0-3.649,0Z",
		transform: "translate(-3.906 -5.681)",
		fill: "#1da193"
	})
});
export { SvgDoneIcon as ReactComponent };
